import { memo } from 'react';
import { Icon } from '@ui/components';

interface IGroupInfoEmptyStateProps {
  hasSearch: boolean;
}

export const GroupInfoEmptyState = memo(({ hasSearch }: IGroupInfoEmptyStateProps) => (
  <div className="flex-1 flex flex-col justify-center items-center py-16 px-6 bg-gradient-to-b from-white via-gray-50/50 to-white">
    <div className="relative mb-4">
      <div className="absolute inset-0 bg-gray-200 rounded-full blur-2xl opacity-50" />
      <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center shadow-lg">
        <Icon type="people" className="text-gray-400 w-10 h-10" />
      </div>
    </div>
    <div className="text-lg font-bold text-gray-900 mb-2 text-center">
      {hasSearch ? 'No members found' : 'No members yet'}
    </div>
    <div className="text-sm text-gray-600 text-center max-w-sm leading-relaxed">
      {hasSearch
        ? 'Try adjusting your search terms to find what you are looking for'
        : 'Members will appear here when they join the conversation'}
    </div>
  </div>
));

GroupInfoEmptyState.displayName = 'GroupInfoEmptyState';
